import gql from 'graphql-tag';
import { get } from 'lodash';
import React from 'react';
import { Query } from 'react-apollo';

const QUERY_NAME =
  'compositions_CaseDealerLocatorPanel_withCaseInboundProgramNumber';

const withCaseInboundProgramNumber = WrappedComponent => componentProps => (
  <Query
    query={gql`
      query ${QUERY_NAME} (
        $caseNumber: String!
      ) {
        case (
          caseNumber: $caseNumber
        ) {
          id
          inboundProgramNumber {
            id
            billTo
          }
        }
      }
    `}
    variables={{ caseNumber: componentProps.caseNumber }}
    skip={!componentProps.caseNumber}
  >
    {({ data }) => (
      <WrappedComponent
        {...componentProps}
        inboundProgramNumber={get(data, 'case.inboundProgramNumber')}
      />
    )}
  </Query>
);

export default withCaseInboundProgramNumber;



// WEBPACK FOOTER //
// ./src/compositions/CaseDealerLocatorPanel/withCaseInboundProgramNumber.js